export const clearWebimLocalStorage = (): void => {
  localStorage.removeItem('WEBIM_VISITOR');
  localStorage.removeItem('WEBIM_VISIT_SESSION_ID');
};
